import React from 'react';
import { FileTextIcon, LayersIcon, ClockIcon, WrenchIcon } from 'lucide-react';
import { Section } from './Section';
const stats = [{
  icon: FileTextIcon,
  label: '300 páginas'
}, {
  icon: LayersIcon,
  label: '6 tomos operativos'
}, {
  icon: ClockIcon,
  label: 'Minuto a minuto del día del evento'
}, {
  icon: WrenchIcon,
  label: '5 herramientas de campo'
}];
const coverage = ['Concepto y diseño', 'Presupuesto y rentabilidad', 'Logística y producción', 'Marketing y ventas', 'Proveedores y contratos', 'Crisis y protocolo'];
export function ProductReveal() {
  return <Section tone="ivory" data-id="element-173" data-mp="2n3p8nbs2n7tv">
      <div className="flex flex-col items-center text-center" data-id="element-174" data-mp="2n3z2xbk5g15d">
        <p className="kicker max-w-[36ch]" data-id="element-175" data-mp="2ibxjn5okda5u">
          El sistema operativo completo para organizadoras de quince años
        </p>

        <h2 className="mt-6 font-serif text-[34px] leading-none tracking-[0.02em] sm:text-5xl md:text-6xl" data-id="element-176" data-mp="1ullcvy521jgu">
          MASTER PLAN 15
        </h2>

        <p className="measure mt-6 font-serif text-lg italic text-gold-dark sm:text-xl" data-id="element-177" data-mp="1b0xmutvy7v76">
          6 tomos + 5 bonos — Del concepto a la rentabilidad, del montaje al
          minuto a minuto, de la crisis a la recomendación.
        </p>

        <p className="measure mt-8 text-[15px] leading-relaxed text-ink-soft sm:text-base" data-id="element-178" data-mp="1juameeoipv28">
          Esto no es un curso de decoración. No son tips de Pinterest. No es
          otro PDF motivacional que se queda en la carpeta de descargas. Es
          ingeniería de eventos: 300 páginas de estructuras de costos,
          cláusulas, cronogramas técnicos, guiones de venta y protocolos de
          crisis que las planners de élite no comparten.
        </p>
      </div>

      <ul className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4" data-id="element-179" data-mp="161l2qgwgp28a">
        {stats.map(({
        icon: Icon,
        label
      }) => <li key={label} className="card-editorial flex flex-col items-center gap-3 px-4 py-6 text-center" data-id="element-180" data-mp="2cipyasccrx9c">
            <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-181" data-mp="2hj49ukd5xpc4" />
            <span className="text-[13px] leading-snug text-ink-soft" data-id="element-182" data-mp="1rrkrkdig7xqd">
              {label}
            </span>
          </li>)}
      </ul>

      <ul className="mt-8 flex flex-wrap justify-center gap-2.5" data-id="element-183" data-mp="1mw5irzzass0t">
        {coverage.map(item => <li key={item} className="rounded-card border border-gold/40 px-4 py-2 text-[12px] uppercase tracking-[0.12em] text-ink-soft" data-id="element-184" data-mp="1wrz0dxrvjbpg">
            {item}
          </li>)}
      </ul>
    </Section>;
}